import styled from "styled-components"

export const HeaderButtons = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
`

export const HeaderCenteredButtons = styled(HeaderButtons)`
  transform: translateX(-50%);
  position: absolute;
  left: 50%;
`
